import { useForm } from '@/common/form/FormContext';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

export const XAxisButton = ({ options }) => {
  const { formValues, assignValue } = useForm();
  const [anchorEl, setAnchorEl] = useState(null);

  const selectedOption = options.find((option) => option.code === formValues.xAxis);

  const select = (option) => {
    assignValue('xAxis', option.code);
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        endIcon={<FontAwesomeIcon icon={far.faChevronDown} size="xs" />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
      >
        {selectedOption?.displayName ?? 'X Axis'}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ list: { dense: true, sx: { py: 0 } } }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option.code}
            divider={index < options.length - 1}
            onClick={() => select(option)}
            sx={{ alignItems: 'flex-start', maxWidth: 320, whiteSpace: 'normal' }}
          >
            <ListItemIcon sx={{ mt: 0.75 }}>
              {formValues.xAxis === option.code && <FontAwesomeIcon icon={far.faCheck} />}
            </ListItemIcon>
            <ListItemText
              primary={option.displayName}
              secondary={option.description}
              slotProps={{ primary: { fontWeight: 600 } }}
            />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
